// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__rAKZR","input":"SearchBar_input__jwwmJ"};